import { SEO } from "@/components/SEO";
import { LegalPage } from "../components/site/legal/LegalPage";

const sections = [
  {
    heading: "Overview",
    body: [
      "Blueprint4Joy® (\"we\", \"us\", \"our\") respects your privacy. This policy explains what information we collect on this website, how we use it, and the choices you have.",
      "By using this site, you agree to the practices described here.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "We collect the information you choose to give us directly — for example, your name and email address when you subscribe to updates, join a waitlist, or reach out through a mailto link.",
      "We do not collect payment information on this site. Book purchases are completed on Amazon, and Amazon's own privacy policy applies to that transaction.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "We use the information you provide to send the updates, resources, or replies you signed up for or requested, and to understand which parts of the site are most helpful so we can improve it.",
      "We do not sell or rent your personal information to third parties.",
    ],
  },
  {
    heading: "Third-Party Links & Services",
    body: [
      "This site links out to services we don't control, including Amazon (book purchases), Interact (the JOYspot™ quiz), and Clubhouse (live rooms). Each of those services has its own privacy policy, which we encourage you to review.",
    ],
  },
  {
    heading: "Your Choices",
    body: [
      "You can unsubscribe from any email list at any time using the link included in our emails, or by writing to us directly.",
      "To ask what information we have on file for you, or to request it be deleted, email lara@blueprint4joy.com.",
    ],
  },
  {
    heading: "Children's Privacy",
    body: [
      "This site is not directed at children under 13, and we do not knowingly collect information from them.",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: [
      "We may update this policy from time to time. The \"Last updated\" date at the top of this page will always reflect the most recent version.",
    ],
  },
  {
    heading: "Contact",
    body: [
      "Questions about this policy? Reach us at lara@blueprint4joy.com.",
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Blueprint4Joy®'s privacy policy — what information we collect, how we use it, and your choices."
        path="/privacy"
      />
      <LegalPage
        eyebrow="Blueprint4Joy®"
        title="Privacy Policy"
        updated="February 2026"
        sections={sections}
      />
    </>
  );
}
